import {
    TRADE_AUTO_LOAN_UNAVAILABLE,
    TRADE_ESTIMATE_LOAN_BALANCE,
    TRADE_FIND_OPEN_LOAN,
    TRADE_LOAN_BALANCE,
    TRADE_LOAN_BALANCE_OPTIONS,
    TRADE_LOAN_CONFIRMATION,
    TRADE_REGISTRATION_DETAILS
} from '@makemydeal/dr-activities-tradein';

// Mirrors TRADEIN_ESTIMATE_METHODS.USER in dr-activities-tradein (Submit for Appraisal); that enum
// lives under improvedWorkflow/components and is not re-exported from the package root.
export const TRADE_IN_USER_SOURCE = 'USER';
export const BROWSE_INVENTORY = 'Browse Inventory';
export const AMOUNT_OWED_SOURCE_PLACEHOLDER = '--';
export const TRADE_PAYOFF_SOURCE = { DEALER: 'Dealer', CONSUMER: 'Consumer' } as const;
export const LOAN_FLOW_ROUTES: readonly string[] = [
    TRADE_LOAN_BALANCE,
    TRADE_LOAN_BALANCE_OPTIONS,
    TRADE_REGISTRATION_DETAILS,
    TRADE_FIND_OPEN_LOAN,
    TRADE_AUTO_LOAN_UNAVAILABLE,
    TRADE_ESTIMATE_LOAN_BALANCE,
    TRADE_LOAN_CONFIRMATION
];
export const CLEARED_LOAN_STEP = { loanStepPending: false, loanStepAnswered: false };
export const UNANSWERED_REGISTRATION_DETAILS = {
    isBuyerRegisteredOwner: undefined,
    isSellingVehicleRegisteredInSameState: undefined
};
